// Must run before the Supabase client strips auth params from the URL.
import "./lib/authRecovery";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// App entry point
createRoot(document.getElementById("root")!).render(<App />);
